import * as React from 'react';
import { render } from 'react-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import { Switch } from 'react-router-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { LoginPage } from './components/LoginPage/LoginPage';
import { UserListPage } from './components/UserListPage/UserListPage';
import { HomePage } from './components/HomePage/HomePage';
import { MembershipPage } from './components/MembershipPage/MembershipPage';
import { ProfilePage } from './components/ProfilePage/ProfilePage';
import { SuperAdminPage } from './components/SuperAdminPage/SuperAdminPage';
import { SubscriptionManagmentPage } from './components/SubscriptionManagmentPage/SubscriptionManagmentPage';
import { CoursesPage } from './components/CoursesPage/CoursesPage';
import { CreateCourse } from './components/CoursesPage/internalComponents/CreateCourse';
import { SchedulePage } from './components/SchedulePage/SchedulePage';
import { NotFoundPage } from './components/NotFoundPage/NotFoundPage';
import LoginServices from './services/LoginServices';
import { FormAdhere2 } from './components/MembershipPage/internalComponents/Adhere2';
import { isNullOrUndefined } from 'util';
import { ShowSubscriptionPage } from './components/ShowSubscriptionPage/ShowSubscriptionPage';
import { ResetPasswordPage } from './components/LoginPage/ResetPasswordPage';
import { ShowCoursePage } from './components/CoursesPage/ShowCoursePage';
import { ShowProfilePage } from './components/ProfilePage/ShowProfilePage';
import { EventPage } from './components/EventPage/EventPage';
import { CreateEventPage } from './components/EventPage/CreateEventPage';
import { EmailValidationPage } from './components/EmailValidationPage/EmailValidationPage';
import { MediasPage } from './components/MediasPage/MediasPage';
import { ManageMediasPage } from './components/MediasPage/ManageMediasPage';
import { DisplayMediaPage } from './components/MediasPage/DisplayMediaPage';
import { MaintenancePage } from './components/MaintenancePage/MaintenancePage';
import Axios, { AxiosResponse } from 'axios';

interface Props {
}

interface State {
    role: string;
    offline: boolean;
}

class App extends React.Component {
    state: State;
    props: Props;

    constructor(props: Props) {
        super(props);
        const type = LoginServices.getInstance().getType();
        this.state = {
            offline: false,
            role: isNullOrUndefined(type) ? '' : type
        };

        Axios.get(
            process.env.REACT_APP_SITE_STATE_URL!
        ).then(
            (response: AxiosResponse<number>) => {
                if (response.data === 0) {
                    this.setState({ offline: true });
                }
            }
        );

    }

    render() {
        if (this.state.offline) {
            return <MaintenancePage />;
        } else {
            return (
                <Router>
                    <Switch>
                        <Route exact={true} path="/" component={LoginPage} />
                        <Route path="/home" component={HomePage} />
                        <Route path="/membership/" component={MembershipPage} />
                        <Route path="/membership2" component={FormAdhere2} />
                        <Route path="/profile" component={ProfilePage} />
                        <Route path="/userlist" exact={true} component={UserListPage} />
                        <Route path="/userlist/:name" component={ShowProfilePage} />
                        <Route path="/admin" component={SuperAdminPage} />
                        <Route path="/subscriptions" exact={true} component={SubscriptionManagmentPage} />
                        <Route path="/subscriptions/:user_id/" component={ShowSubscriptionPage} />
                        <Route path="/courses" exact={true} component={CoursesPage} />
                        <Route path="/courses/newCourse" component={CreateCourse} />
                        <Route path="/courses/:name" component={ShowCoursePage} />
                        <Route path="/schedule/create" component={CreateEventPage} />
                        <Route path="/schedule/:id" component={EventPage} />
                        <Route path="/schedule" component={SchedulePage} />
                        <Route path="/reset/:token" component={ResetPasswordPage} />
                        <Route path="/emailvalidation" exact={true} component={EmailValidationPage} />
                        <Route path="/emailvalidation/:token" component={EmailValidationPage} />
                        <Route path="/medias" component={MediasPage} />
                        <Route path="/gestion-media" exact={true} component={ManageMediasPage} />
                        <Route path="/gestion-media/:id" component={DisplayMediaPage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </Router>
            );
        }
    }
}

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.tsx